import { DatePipe } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { Subscription } from 'rxjs';
import { DynamicFormService } from '../../dynamic-form/dynamic-form.service';
import { DateFormatPipe, EODDateFormatPipe, TimeFormatPipe, TimeFormatPipeNew } from "src/app/_helpers/pipe.module";
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';
import { TranslateModule } from '@ngx-translate/core';
import { ICONS } from '../../../../_helpers/icons.constants';

@Component({
  selector: 'formly-justification-notes',
  templateUrl: "./formly-justification-notes.component.html",
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, FormlyModule, TranslateModule]
})
export class FormlyJustificationNotesComponent extends FieldType implements OnInit, OnDestroy {

  isFormSubmitted: boolean = false;
  formSubmissionSubscription: Subscription;
  public ICONS = ICONS;
  constructor(private dynamicFormService: DynamicFormService, public datepipe: EODDateFormatPipe, public dateFormatPipe: DateFormatPipe, public timeFormatPipeNew: TimeFormatPipeNew) {
    super();
  }

  ngOnInit() {
    this.formSubmissionSubscription = this.dynamicFormService.getFormSubmittedEvent().subscribe(data => {
      this.isFormSubmitted = data;
    });
  }

  ngOnDestroy() {
    if (this.formSubmissionSubscription) {
      this.formSubmissionSubscription.unsubscribe();
    }
  }

  onClick(item) {
    this.to.click(item, this.formControl.value);
  }

  fnActionString(item) {
    if (item) {
      if (this.field.templateOptions?.cTimeformat) {
        return this.datepipe.transform(item.createdOn) + " " + item.actionString;
      }
      let date = this.dateFormatPipe.transform(item.createdOn, "dd-MMM-yyyy");
      let time = this.timeFormatPipeNew.transform(item.createdOn, "HH:mm");
      let actionString = date + " / " + time + " " + item.actionString
      return actionString;
    }
    return '';
  }

}
